import GeneralConfirmModal from './GeneralConfirmModal';

export default GeneralConfirmModal;
